<template>
        <div class="popup"  @touchmove.prevent>
            <div class="popup_div cover_img" >
                <i class="esc" @click="escFun"><img src="@/assets/img/shutDown.png" alt=""></i>
                <h5 class="popup_title">隐私协议</h5>
                <div class="center_text">
                        更新日期：2020年07月07日
                        <br>
                        生效日期：2020年07月07日
                        <br>
                        特别提示：
                        <br>
                        我们深知个人信息对用户（以下简称用户或您）的重要性，并会尽全力保护您的个人信息安全可靠。根据法律法规、国家标准等规定，制定以下《vision麻醉眼界隐私政策》（以下简称本政策或本隐私政策）。本政策要点如下：
                        <br>
                        1.为便于您注册成为vision麻醉眼界用户并使用vision麻醉眼界的产品或服务，您需要提供相关个人信息，我们将逐项列举说明，您有权拒绝或撤回授权。
                        <br>
                        2.您可以查询、修改、删除您的个人信息，改变您同意授权的范围，注销您的账号，我们为您提供行使上述权利的途径。
                        <br>
                        3.我们将努力采取各种安全保护措施以保护您提供的个人信息，防止数据泄漏。
                        <br>
                        4.请确认您为18周岁以上成年人。
                        <br>
                        为了满足法律法规的要求及特定业务功能所必需，某些业务功能（例如注册成为vision麻醉眼界用户）需要您提供某些个人敏感信息（例如手机号码），我们将在本隐私政策中逐项列明，并做特别标注。个人敏感信息的定义可参考本隐私政策第11部分。特别提示，您向我们提供个人敏感信息前请慎重考虑后再提供。
                        <br>
                        您可以根据以下索引阅读相应章节，以了解本政策的详细内容：
                        <br>
                        1.我们如何收集您的个人信息
                        <br>
                        2.我们如何使用 Cookie 和同类技术
                        <br>
                        3.我们如何使用收集的信息
                        <br>
                        4.我们如何共享、转让、公开披露您的个人信息
                        <br>
                        5.信息的存储
                        <br>
                        6.我们如何保护您的个人信息
                        <br>
                        7.您的权利
                        <br>
                        8.我们如何处理未成年人的个人信息
                        <br>
                        9.本政策如何更新
                        <br>
                        10.如何联系我们
                        <br>
                        11.名词定义
                        <br>
                        本政策适用于上海蓄智文化传媒有限公司（以下简称vision麻醉眼界或我们）及vision麻醉眼界关联公司提供的产品及服务，包括但不限于vision麻醉眼界网（anesthesia_vision@126.com）、vision麻醉眼界APP等。我们的注册/常用办公地址为：上海市浦东新区锦绣路3891号B410室。如我们或关联公司的产品或服务使用了vision麻醉眼界网的产品或服务（例如使用vision麻醉眼界账号登录）但未设独立隐私政策的，则本政策同样适用于该部分产品或服务。我们或关联公司向您提供的产品或服务单独设立隐私政策的（如《vision麻醉眼界隐私政策》），则相应产品或服务适用对应的隐私政策。
                        <br>
                        vision麻醉眼界的产品或服务中可能含有第三方产品和/或服务的链接或信息。如果第三方产品和/或服务要求您填写相关信息，请仔细查看该第三方的隐私政策，并审慎提供个人信息。本隐私政策不适用于第三方向您收集信息的行为，vision麻醉眼界无法控制第三方的行为，亦不会对第三方收集和/或使用您信息的行为承担任何责任。
                        <br>
                        请在使用我们的产品或服务前，仔细阅读并充分了解本隐私政策内容。如果您不同意本政策的内容，可能导致我们无法为您提供相应的产品和/或服务。一旦您开始使用我们的产品或服务，即表示您已充分理解并同意本政策。
                        <br>
                        1.我们如何收集您的个人信息
                        <br>
                        我们提供的产品或服务包括基本业务功能和扩展业务功能。我们提供的基本业务功能需要依赖部分信息才得以运行，您选择使用该项业务功能时，则需要向我们提供或允许我们收集必要的信息，否则基本业务功能将无法正常运行，我们将无法为您服务；如您还选择使用扩展业务功能，则需要向我们提供或允许我们收集扩展业务功能必要的信息，否则扩展业务功能将无法正常运行，但不影响您使用基本业务功能。
                        <br>
                        我们基于不同业务功能收集您的个人信息详情如下：
                        <br>
                        1.1帮助您注册成为vision麻醉眼界用户
                        <br>
                        1）当您注册vision麻醉眼界账号时，为落实网络实名制要求，向您提供用户服务，您需要提供您的手机号、验证码、密码，并提供您创建的用户名、性别、职业、城市信息。如果您不提供上述信息，您将无法成为vision麻醉眼界用户，使用发布作品、发布文章、收藏作品等功能，但不影响您以游客身份使用浏览、搜索服务。
                        <br>
                        2）当您注册vision麻醉眼界账号后，为更好地为您提供个性化服务（如同城服务），或者您希望其他人了解您或联系您，您可以选择手机号，地址等部分信息（仅自己可见/所有人可见）您不提供上述信息不影响您使用vision麻醉眼界的其他服务。
                        <br>
                        1.2第三方账号登录
                        <br>
                        为便于您通过第三方账号登录vision麻醉眼界，您可以选择绑定微信账号。当您使用第三方账号（微信）登录或绑定vision麻醉眼界账号时，为了记住您的身份，我们可能从第三方间接获取您在该第三方平台上的公开信息（包括昵称、头像、性别）。如果您拒绝我们从第三方平台上获取上述公开信息，您将无法使用第三方账号登录，但不影响其他服务。您可以随时解绑第三方账号。
                        <br>
                        1.3为您提供内容搜索、浏览服务
                        <br>
                        为向您提供内容搜索、浏览服务，识别账号异常状态，了解设备适配性，保证我们提供的产品或服务的正常运行，我们会收集您的操作系统版本、操作系统语言、浏览器类型、设备型号、设备MAC地址、唯一设备识别码、软件列表、联网方式、手机分辨率、IP地址、搜索词、访问网页、访问时间、服务日志（例如点赞）。
                        <br>
                        前述信息是我们提供产品或服务之必需，您不同意我们收集前述信息将导致您无法使用vision麻醉眼界的产品或服务。
                        <br>
                        1.4为您提供内容发布服务
                        <br>
                        为向您提供内容发布服务，例如上传作品、写文章、发表评论，我们会收集您的上传内容、发布时间。
                        <br>
                        请注意，如您发布内容中包含您或者第三方的个人信息的，请谨慎发布。一旦发布，即代表您授权vision麻醉眼界收集并公开发布。如包含第三方个人信息的，则您确保已征得第三方授权同意；如包含儿童个人信息的，则您确保已征得儿童监护人授权同意。
                        <br>
                        您不同意vision麻醉眼界收集前述信息则无法使用内容发布服务，但不影响您使用vision麻醉眼界的其他服务。
                        <br>
                        1.5为您提供关注、收藏服务
                        <br>
                        您使用vision麻醉眼界的产品或服务，您可以对感兴趣的用户、团体或收藏夹添加关注，或者对感兴趣的内容添加收藏。您可以在“我的关注”中查看您关注的用户或团体发布的内容、生活动态或关注的收藏夹的更新情况等；您可以在“我的收藏”中查看您添加收藏的内容。您可以随时取消关注或移除收藏内容。
                        <br>
                        1.6订阅学习音频
                        <br>
                        当您订阅学习音频时，我们会收集您的订阅记录。如您选择订阅付费音频时，您需要通过第三方支付平台（微信或支付宝）支付费用。我们会收集您的订单号及订单金额，并将前述信息共享给第三方平台以完成支付。
                        <br>
                        您不同意vision麻醉眼界收集前述信息将无法订阅学习音频，但不影响您使用vision麻醉眼界的其他服务。
                        <br>
                        1.7为您提供客户服务
                        <br>
                        在您使用vision麻醉眼界的产品或服务过程中，我们可能根据您提供的信息为您提供必要的客户服务，如第三方通知vision麻醉眼界您上传内容侵犯其合法权益时，vision麻醉眼界可能通过您在注册时提供的联系方式与您取得联系并告知您前述通知，以便您做出合适的选择。
                        <br>
                        当您与我们联系处理您的问题时，您可能需要提供必要的个人信息，以便我们核实您的用户身份、解决您的问题。如您拒绝提供，我们可能无法响应您的需求。
                        <br>
                        1.8为您提供产品或服务所必需
                        <br>
                        为向您提供vision麻醉眼界产品或服务，识别账号异常状态，了解设备适配性，保证我们提供的产品或服务的正常运行，帮助优化您的服务体验，改进我们的产品或服务，当您使用vision麻醉眼界产品或服务时，我们会收集您的以下信息：
                        <br>
                        1）设备相关信息，例如操作系统、操作系统版本、操作系统语言、设备品牌、设备型号、设备类型、设备位置所在 IP 地址、设备唯一识别码等。
                        <br>
                        2）服务日志信息，例如登陆记录、搜索查询内容、网站浏览记录、点击记录、软件使用记录等。
                        <br>
                        3）与产品或服务相关的其他信息，例如您的关注、您的收藏、您的粉丝数量、您的人气数、您主页的访问数量、您简历的投递记录等。
                        <br>
                        需要您注意的是，单独的设备相关信息、服务日志信息等无法识别特定自然人身份，除非将这类信息与其他个人身份信息结合使用，否则将不被视为个人信息。
                        <br>
                        我们还可能将您的上述信息用于数据统计，例如将您的搜索查询记录用于日搜索词统计，您的浏览记录用于内容人气统计。
                        <br>
                        1.9安全保障服务
                        <br>
                        为确保我们提供的产品或服务安全可靠，预防计算机病毒、网络攻击、网络侵入及网络漏洞等网络安全事件，保护您、其他用户、vision麻醉眼界的人身和财产安全，我们需要收集用户信息、常用设备信息、服务日志信息等，并可能单独或融合使用您的前述信息，综合判断您的账户安全、进行身份验证、检测及防范安全事件、进行数据备份，并采取必要的记录、审计、分析、处置措施。
                        <br>
                        1.10基于设备权限的扩展业务功能
                                        如您通过vision麻醉眼界APP使用vision麻醉眼界的产品或服务，经您授权同意，我们会调用一些您的设备权限，以便为您提供相应产品或服务，您不开启相应权限将无法使用对应的功能，但不影响其他业务功能。以下是vision麻醉眼界APP调用设备权限的目的及对应的业务功能。您可以在设备的设置功能中选择关闭全部或部分权限，从而拒绝vision麻醉眼界APP收集相应信息。在不同设备中，权限名称、分类方式、显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。
                        <br>
                        1）位置权限，如您选择使用“发现附近的设计师”的业务功能，您需要授权vision麻醉眼界获取您的当前位置。您可以不授权vision麻醉眼界获取您的位置权限或关闭相应权限，您将无法实现前述功能，但不影响您使用其他服务。
                        <br>
                        2）相册权限，您授权vision麻醉眼界获取您的相册权限，则您可以直接从相册中选取图片、视频等内容，用于发布作品、更换头像、发布生活圈等。您可以不授权vision麻醉眼界获取相册权限或关闭相应权限，您将无法使用前述功能，但不影响您使用其他服务。
                        <br>
                        3）相机/摄像头权限，您授权vision麻醉眼界获取您的相机/摄像头权限，则您可以直接通过相机/摄像头即时上传头像、扫描二维码、发布生活圈等。您可以不授权vision麻醉眼界获取相机/摄像头权限或关闭相应权限，您将无法使用前述功能，但不影响您使用其他服务。
                        <br>
                        4）通知权限，您授权vision麻醉眼界获取您的通知权限，则收到新的评论、留言、点赞、私信、粉丝关注、系统公告、系统通知等，您将获得精准实时的移动推送服务。您可以不授权vision麻醉眼界获取通知权限或关闭相应权限，您将无法使用前述功能，但不影响您使用其他服务。
                        <br>
                        提醒您注意，您开启相关权限即意味着您授权我们可以收集和使用相关个人信息来为您提供相应服务，您关闭相关权限即意味着您取消了相应授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但您收回授权的决定不会影响此前基于您的授权而开展的个人信息的收集和使用。
                        <br>
                        1.11无需征得同意的情形
                                        根据法律法规、国家标准规定，以下情形中，我们可能会依法收集并使用您的个人信息无需征得您的授权同意：
                                        1）与国家安全、国防安全直接相关的。
                        <br>
                        2）与公共安全、公共卫生、重大公共利益直接相关的。
                        <br>
                        3）与犯罪侦查、起诉、审判和判决执行等直接相关的。
                        <br>
                        4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您的同意的。
                        <br>
                        5）所收集的个人信息是您自行向社会公众公开的。
                        <br>
                        6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
                        <br>
                        7）根据您要求签订和履行合同所必需的。
                        <br>
                        8）用于维护我们所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。
                        <br>
                        9）法律法规规定的其他情形。
                        <br>
                        1.12您理解并同意，我们向您提供的产品或服务是不断更新发展的。如果某一项产品或服务未能在前述说明中且确有必要收集您的信息的，我们会通过页面提示、私信、网站公告、表单等方式另行征得您的同意。
                                        2.我们如何使用 Cookie 和同类技术
                                        2.1为确保网站正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标志符、站点名称以及一些号码和字符。借助Cookie，网站能够记住您的用户身份、存储您的偏好。
                        <br>
                        我们不会将Cookie用于本政策所述目的之外的其他用途。您可根据自己的偏好管理或删除Cookie。如您的浏览器允许，您可以通过浏览器设置阻止Cookie。但如果您这么做，可能会影响您安全访问我们的网站，且可能在每一次访问我们的网站时需要更改用户设置。
                        <br>
                        2.2 除Cookie之外，我们使用网络信标（Web Beacons）来收集页面的访问量、点击量；还使用了实体标签（Etag）来做静态资源的缓存，以便加速网站的访问速度，提升您的浏览体验。
                        <br>
                        3.我们如何使用收集的信息
                                        3.1向您提供我们的产品或服务，详情见本隐私政策第1部分。
                        <br>
                        3.2在vision麻醉眼界向您提供产品或服务时，用于身份验证、客户服务、安全防范、备份等用途，以确保我们向您提供的产品和服务的安全性。
                        <br>
                        3.3为改善我们的产品或服务，我们可能会对收集的信息进行去标识化或匿名化处理后，进行内部审计、数据统计、数据分析和研究等。在不泄露您个人信息的前提下，可能用于商业化使用，例如对外宣传。
                        <br>
                        3.4当我们要将信息用于本政策未载明的其他用途时，会事先征得您的同意。
                        <br>
                        3.5当我们要将基于特定目的收集而来的信息用于其它目的时，会事先征得您的同意。
                        <br>
                        4.我们如何共享、转让、公开披露您的个人信息
                                        4.1 共享
                                        我们不会向任何公司、组织和个人共享您的个人信息，但下列情况除外：
                        <br>
                        1）在获得明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
                        <br>
                        2）我们可能会根据法律法规规定、诉讼或争议解决的需要、按政府主管部门或司法机关的要求，对外共享您的个人信息。
                        <br>
                        3）与关联公司共享：为便于我们及关联公司向您提供各项产品或服务、验证您的身份、识别您的账号异常等，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。
                        <br>
                        4）与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些业务将由授权合作伙伴协助实现。我们可能会与合作伙伴共享您的某些个人信息，以更好地实现用户服务和vision麻醉眼界业务发展。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。
                        <br>
                        目前，我们的授权合作伙伴包括以下几大类型：
                        <br>
                        a.广告类合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或手机号，通过这些信息可以联系到您或识别您的身份）与广告类合作伙伴分享。我们可能会向这些合作伙伴提供有关其广告覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行汇总，以便他不会识别到您个人。
                        <br>
                        b.业务类合作伙伴。为了完整地实现我们的某一具体业务服务，我们与业务类合作伙伴合作，共同为您提供业务服务，以便实现该业务的功能和您的需求。例如求职服务，我们需要将您的简历共享给您的投递企业，以便能实现您的求职需求；等等。
                        <br>
                        c.功能类服务提供商。为实现我们的业务功能，我们与功能类合作伙伴合作，共同为您提供服务，以便实现您的需求。包括支付类合作伙伴，例如我们需要将您的订单号和订单金额与第三方支付机构（例如微信或支付宝等）共享以实现其确认您的支付指令并完成支付；登录类合作伙伴，例如我们需要将您的手机号与登录运营商（例如阿里云）共享以实现登录需求；等等。
                        <br>
                        d.分析类服务提供商。例如数据分析，我们需要将您的设备信息、服务日志信息等共享给数据分析类合作伙伴，以便能分析我们产品或服务的基本情况，用于维护或改进我们的产品或服务；等等。
                        <br>
                        e.其他供应商、服务提供商或者其他合作伙伴。为了提供、改进和完善我们的产品或服务，我们可能会将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们产品或服务的基本情况、协助我们向您提供产品或服务、投融资活动中的尽职调查等。
                        <br>
                        f. 涉及嵌入第三方SDK收集、使用个人信息的情形逐项举例：
                        <br>
                        产品或服务 收集、使用个人信息场景 收集、使用个人信息类型 第三方SDK名称
                                        vision麻醉眼界网站/APP 数据采集、分析 账户信息（如性别、职业）、设备信息（如操作系统版本、唯一设备标识符）、位置信息（如城市、IP地址） GrowingIO无埋点SDK
                                        vision麻醉眼界网站/APP 第三方登录、分享 设备信息（如浏览器类型）、位置信息（如IP地址） 微信 SDK 
                                        新浪微博 SDK QQ SDK
                                        vision麻醉眼界APP 数据采集、统计 设备信息（如操作系统版本、唯一设备标识符）、位置信息（如IP地址） 友盟移动统计SDK
                                        vision麻醉眼界APP 异常上报 设备信息、崩溃日志 腾讯Bugly SDK
                                        vision麻醉眼界APP 定位 设备信息、位置信息（如GPS数据） 高德地图SDK
                                        vision麻醉眼界APP 推送 设备信息 阿里云移动推送SDK
                                        vision麻醉眼界网站 视频上传、播放 设备信息（如浏览器类型）、位置信息（如IP地址） 阿里云视频上传、播放SDK
                                        对我们与之共享个人信息的第三方，我们会与其签署严格的保密约定，要求他们按照本隐私政策及相关法律法规要求处理个人信息。
                        <br>
                        4.2 转让
                                        目前我们不会将您的个人信息转让给vision麻醉眼界及关联公司外的任何第三方，但下列情况除外：
                        <br>
                        1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他第三方转让您的个人信息。
                        <br>
                        2）在涉及合并、收购、资产转让等情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新征求您的同意。
                        <br>
                        4.3 公开披露
                                        我们不会公开披露您的个人信息，但下列情况除外：
                        <br>
                        1）获得您明确同意后或基于您的主动选择。
                        <br>
                        2）基于法律的披露：在法律、法律程序、诉讼、政府主管部门或司法机关要求的情况下，我们可能会公开披露您的个人信息。
                        <br>
                        4.4 根据法律法规及国家标准，以下情形中我们可能会共享、转让、公开披露您的个人信息无需征得您的同意：
                                        1）与国家安全、国防安全直接相关的。
                        <br>
                        2）与公共安全、公共卫生、重大公共利益直接相关的。
                        <br>
                        3）与犯罪侦查、起诉、审判和判决执行等直接相关的。
                        <br>
                        4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您的同意的。
                        <br>
                        5）您自行向社会公众公开的个人信息。
                        <br>
                        6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
                        <br>
                        5.信息的存储
                                        5.1我们将从中华人民共和国境内获得的信息存放于中华人民共和国境内。如因业务需求或其他原因需要跨境传输的，我们会另行征得您的明确同意，并明确告知您出境个人信息类型。
                        <br>
                        5.2我们承诺您个人信息的存储时间始终处于合理必要期限内。
                        <br>
                        5.3当我们的产品或服务停止运营时，我们会及时停止对您个人信息的收集，将以推送通知、公告等形式通知您，并根据法律法规的要求尽快对已收集的个人信息进行删除或匿名化处理。
                        <br>
                        6.我们如何保护您的个人信息
                                        6.1我们努力采用各种安全保护措施以保护您提供的个人信息，防止数据遭到未授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据时受SSL加密保护；我们对vision麻醉眼界网站提供https安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；我们会进行安全和个人信息保护培训，加强员工对于保护个人信息重要性的认识。
                        <br>
                        6.2我们的重要信息系统已经通过网络安全等级保护三级的备案和测评，并与监管部门、第三方测评机构建立良好的沟通机制，确保按照网络安全等级保护三级的技术标准和管理规范进行网络安全建设，保障个人信息安全。
                        <br>
                        6.3互联网并非绝对安全的环境，我们强烈建议您采取积极措施保证个人信息的安全，如：请使用复杂密码，定期修改账号密码，不要将账号密码等个人信息泄漏给他人。如因我们的原因导致您的个人信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损的，我们将承担相应的法律责任。
                        <br>
                        6.4如不幸发生个人信息安全事件，我们将按照法律法规的要求，启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
                        <br>
                        7.您的权利
                                        按照中国法律法规、国家标准，我们保障您对自己的个人信息行使以下权利：
                        <br>
                        7.1 查询、修改您的个人信息
                                        当您注册成为vision麻醉眼界的用户后，您可以进入您的账户(网页端：用户头像→资料与账号/我的简历/我的关注/我的收藏等；APP端：我的→用户头像/设置等)随时查询、修改您提交给我们的或我们收集的信息，包括基本信息、简历信息、关注信息、收藏信息、绑定的第三方账号信息等。出于安全性和身份识别的考虑，您在修改您的某些信息时（如注册联系电话），需要通过输入验证码等方式核实您的身份。
                        <br>
                        需要特别说明的是，根据法律法规的要求或者我们业务运营的需要，我们收集的某些信息（例如订单信息）可能无法修改。
                        <br>
                        如您无法通过上述路径查询、修改您的个人信息，您可以随时通过第10条列明的方式联系我们。
                        <br>
                        7.2 更正您的个人信息
                                        当您发现我们处理您的个人信息有错误时，您有权要求我们作出更正，您可以随时通过第10条列明的方式联系我们。
                        <br>
                        7.3 删除您的个人信息
                                        您可以进入您的账户删除您的部分信息。以下情形中，您可以通过第10条列明的方式联系我们向我们提出删除个人信息的请求：
                        <br>
                        1）如果我们处理个人信息的行为违反法律法规。
                        <br>
                        2）如果我们收集、使用您的个人信息，却未征得您的同意。
                        <br>
                        3）如果我们处理个人信息的行为违反了与您的约定。
                        <br>
                        4）如果您注销了vision麻醉眼界账号。
                        <br>
                        5）如果我们不再为您提供产品或服务。
                        <br>
                        如我们决定响应您的请求，我们还将同时通知从我们获得您的个人信息的实体，要求其尽快删除，除非法律法规另有规定，或者这些第三方获得您的独立授权。
                        <br>
                        当您从我们的服务中删除信息后，按照法律法规要求和安全技术，我们可能无法立即从备份系统中删除相应的信息。但我们将根据法律法规的要求尽快删除相应信息或做匿名化处理。
                        <br>
                        7.4 改变您同意授权的范围
                                        每个业务功能需要一些基本的个人信息才能完成（详见本政策第1部分）。对可选同意授权范围，您可以进入您的账户随时给予或收回您的授权同意
                                        当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息的处理。您收回同意后可能将导致您无法使用部分功能，但不影响其他功能的使用。
                                        7.5 注销您的账户
                                        您随时可注销此前已注册的账户，您可以通过与我们联系。注销前我们将验证您的个人身份等信息，以确保是您本人。
                        <br>
                        在注销账户后，我们将停止为您提供产品或服务，按照法律法规要求尽快删除您的个人信息或做匿名化处理。您注销账户的行为是不可逆行为，您重新注册vision麻醉眼界的用户，即成为新的用户。您无法恢复已注销账户的任何信息或服务。
                        <br>
                        7.6 响应您的上述请求
                                        1）为保障安全，我们可能会要求您先验证您的身份，再响应您的上述请求。您可以随时通过第10条列明的方式联系我们，一般情况下我们将在15日内作出回复。
                        <br>
                        2）对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求（例如，涉及备份磁带上存放的信息），我们可能会予以拒绝。
                        <br>
                        3）在以下情形中，按照法律法规要求，我们将无法响应您的请求：
                        <br>
                        a.与国家安全、国防安全直接相关的；
                        <br>
                        b.与公共安全、公共卫生、重大公共利益直接相关的；
                        <br>
                        c.与犯罪侦查、起诉、审判和判决执行等直接相关的；
                        <br>
                        d.有充分证据表明您存在主观恶意或滥用权利的；
                        <br>
                        e.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
                        <br>
                        f.涉及商业秘密的。
                        <br>
                        8.我们如何处理未成年人的个人信息
                                        我们的产品、网站和服务主要面向成人。若您是18周岁以下的未成年人，请不要注册成为vision麻醉眼界的用户。
                        <br>
                        如果您是儿童的父母或其他监护人，当您监护的儿童注册成为vision麻醉眼界的用户，请通过第10条列明的联系方式与我们联系。如果您同意您监护的儿童使用vision麻醉眼界的产品或服务，我们只会在受到法律允许、您的明确同意或者保护儿童所必要的情况下收集、使用或公开披露儿童的个人信息。
                        <br>
                        如果我们发现自己在未事先获得可证实的父母或其他监护人同意的情况下收集了儿童的个人信息，则会设法尽快删除。
                        <br>
                        9.本政策如何更新
                                        9.1我们会适时根据具体情况对本隐私政策进行修订，并会通过标签，公告、推送、邮件等适当方式提醒您。
                        <br>
                        在您知晓或应当知晓上述更新后，您仍然选择继续使用我们的产品或服务，视为您对更新后隐私政策的接受。
                        <br>
                        9.2在以下情况下我们可能会对本隐私政策进行更新：
                        <br>
                        1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
                        <br>
                        2）我们的所有权结构、组织架构等方面发生重大变化。如业务调整等引起的所有者变更等；
                        <br>
                        3）个人信息共享、转让或公开披露的主要对象发生变化；
                        <br>
                        4）您参与个人信息处理方面的权利及其行使方式发生重大变化；
                        <br>
                        5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；
                        <br>
                        6）个人信息安全影响评估报告表明存在高风险时。
                        <br>
                        9.3我们还会将本隐私政策的旧版本存档，供您查阅。
                        <br>
                        10.如何联系我们
                                        10.1我们已设立了个人信息保护负责人，如果您对本隐私政策有任何疑问、意见或建议，可以通过以下方式与我们联系，一般情况下我们将在15日内回复：
                                        1）线上提交问题：网页端：设置→联系我们；APP端：设置→联系我们
                        <br>
                        2）发送邮件至：anesthesia_vision@126.com
                        <br>
                        3）邮寄函件至：上海市浦东新区锦绣路3891号B410室，邮编：201204
                        <br>
                        10.2如果您对我们的回复不满意或认为我们的个人信息处理行为损害了您的合法权益，您可以向被告住所地有管辖权的人民法院提起诉讼。
                        <br>
                        11.名词定义
                                        11.1个人信息：指以电子或者其他方式记录的能够单独或者与他人信息结合识别特定自然人身份或者反映特定自然人活动状况的各种信息。
                        <br>
                        11.2个人敏感信息：指一旦泄露、非法提供或滥用可能导致人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。包括身份证件号码、个人生物识别信息、银行账号、通信记录和内容、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息、14岁以下（含）儿童个人信息等。
                        <br>
                        11.3匿名化：通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。个人信息经匿名化处理后所得的信息不属于个人信息。
                        <br>
                        11.4去标识化：通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息的过程。
                        <br>
                        11.5删除：在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。
                        <br>
                        注：前述名词定义出自《GB/T 35273-2017 信息安全技术 个人信息安全规范》。如对本隐私政策其他名词有疑问的，可参考前述国家标准，或者您可以通过第10条列明的方式与我们联系。
                        <br>
                        隐私政策历史版本：
                                        vision麻醉眼界隐私政策1.0
                </div>
            </div>
        </div>
    </template>
    
    <script>
        export default {
            name: 'popup',
            data() {
                return {
                 
                }
            },
            props: {
                is_sign:{
                    type:Boolean,
                    default:false
                },
               
            },
            watch:{
                is_sign:function(eve){
                    let that = this;
                    if(eve == true){
                        
                    }
                }
            },
            methods: {
                escFun(){
                    this.$emit('privacyFun',2);
                }
    
    
            },
            mounted() {
               
            },
        }
    </script>
    
    <!-- Add "scoped" attribute to limit CSS to this component only -->
    <style scoped>
        .popup{
            position: fixed;
            top:0;left:0;right: 0;bottom: 0;
            background: rgba(0,0,0,.4);
            z-index: 999;
            
        }
        .popup .popup_div{
            position: absolute;
            top:50%;
            width: 60vw;
            left: 50%;
            transform: translate(-50%,-50%);
            background-color: #fff;
            border-radius: 20px;
            box-shadow: 0 0 35px rgba(0,0,0,.16);
            padding: 40px 20px 40px 30px;
    
        }
        .popup .popup_div .esc{
            position: absolute;
            right: 10px;top:10px;
            cursor: pointer;
            width: 26px;height: 26px;color:#666;
        }
        .integral{
            position: absolute;
            left: 16px;
            top:16px;font-size: 20px;
            align-items: flex-end;
        }
        .integral>i{
            width: 30px;
            margin-right: 6px;
        }
        .integral>span{
            color:#FCBA07;
        }
        .sign_title{
            font-size: 25px;
            color:#1a1a1a;
            text-align: center;
        }
        .number_div{
            margin:20px auto;
            align-items: flex-end;
        }
        .number_div .tag{
            font-size: 22px;
            color:#333;
            margin-left: 10px;
        }
        .number_div .number{
            width: 54px;
            height: 88px;
            border-radius: 6px;
            background: #fff;
            box-shadow: 3px 0 7px rgba(0, 0, 0, 0.35);
            margin: 0 10px;
            font-size: 48px;
            color:#F04C5A;
        }
        .popup_div .prompt{
            font-size: 22px;
            margin: 10px auto;
            text-align: center;
        }
        .popup_div .sign_button{
            width: 240px;
            height: 55px;
            border-radius: 28px;
            margin: 20px auto 0 auto;
            font-size: 28px;
            color:#fff;
            background-image: linear-gradient(90deg,#F54050,#EC3141);
            border:0;
        }
        .popup_div .prompt.prompt_num{
            color:#FCBA07;
            font-size: 24px;
        }
        .popup_title{
            font-size: 20px;
            font-weight: bold;
            text-align: center;
            padding-bottom:20px;
        }
        .center_text{
            max-height: 60vh;
            overflow-y: auto;
            font-size: 14px;
        }
    
    
        /* 手机端样式哦 */
        .popup.mobile .popup_div{
            max-width: 80%;
            min-width: 60%;
            width: 70%;
            border-radius: 1rem;
            padding: 3rem 0;
        }
        .popup.mobile .popup_div .integral{
            font-size: 1.2rem;
            align-items: flex-end;
            color:666;
            top:1rem;
            left: 1rem;
        }
        .popup.mobile .popup_div .integral>i{
            width: 1.6rem;
        }
        .popup.mobile .popup_div .esc{
            width: 1.8rem;
            right: 1rem;top:1rem;
            height: auto;
        }
        .popup.mobile .popup_div .sign_title{
            font-size: 1.4rem;
            color:#1a1a1a;
            
        }
        .popup.mobile .popup_div .number_div .number{
            width: 2.7rem;
            height: 4.4rem;
            border-radius: .3rem;
            font-size:2.4rem;
            color:#F04C5A;
            margin: 0 .3rem;
        }
        .popup.mobile .popup_div .number_div .tag{
            font-size: 1.1rem;
            color:#333;
        }
        .popup.mobile .popup_div .prompt{
            font-size: 1.2rem;
            color:#333;
        }
        .popup.mobile .popup_div .sign_button{
            width: 70%;
            height: 4rem;
            font-size: 2rem;
        }
        .popup.mobile .popup_div .prompt_num.prompt{
            color:#FCBA07;
            font-size: 1.4rem;
        }
    </style>


// WEBPACK FOOTER //
// src/components/tool/PC_privacy.vue